<template>
  <div class="login-bg">
    <div class="login-bg-top">
      <div class="name"></div>
      <div class="right"></div>
      <div class="wuyan"></div>
    </div>
    <div class="login-bg-body">
      <div class="gate"></div>
      <div class="people"></div>
    </div>
    <div class="login">
      <el-form ref="form" :model="form" class="form" :rules="rules" style="padding-top: 135px;">
        <el-form-item prop="telephone">
          <el-input
            v-model.number="form.telephone"
            placeholder="请输入手机号"
          >
          <i slot="prefix" class="iconfont icon-yonghu"></i>
          </el-input>
        </el-form-item>

        <el-form-item style="width:100%" prop="verifySms">
          <el-input v-model="form.verifySms" placeholder="输入验证码" style="width:140px"></el-input>
          <el-button type="primary" style="float: right" @click="handleVerifyCode">{{sms.label}}</el-button>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码">
          <i slot="prefix" class="iconfont icon-password"></i>
          </el-input>
        </el-form-item>
        <!-- <p>
          <el-input v-model="number" placeholder="输入图中数字"></el-input>
        </p>-->
        <div class="button">
          <p>
            <span class="user-register" @click="goLogin">返回登录</span>
            <!-- <span class="send" @click="handleReset">重置</span> -->
          </p>
          <el-button class="login-button " @click="handleRegister">注册</el-button>
          <el-button class="reset-button" @click="handleReset">重置</el-button>
        </div>
      </el-form>
    </div>
    <div class="login-bg-footer">
     <portal-footer></portal-footer>
    </div>
  </div>
</template>

<script>
import { doLogin, doRegister, doSms, doForget } from "../../actions/auth/login";
import { encryptByDES, _security } from "../../utils/crypto";
import { newGuid } from "../../utils/guid";
import { validatePhone } from "../../utils/validate";

let handleValidPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入电话号码"));
  } else if (!validatePhone(value)) {
    callback(new Error("请输入正确的11位手机号码"));
  } else {
    callback();
  }
};

export default {
  data() {
    return {
      loading: {
        display: false,
        background: null,
        text: null
      },
      sms: {
        second: 0,
        label: "获取验证码",
        timer: null,
        telephone: null
      },
      form: {
        telephone: "",
        userName: "",
        password: "",
        verifySms: "",
        verifyGuid: ""
      },
      number: "",
      rules: {
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" }
        ],
        verifySms: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        telephone: [
          { required: true, trigger: "blur", validator: handleValidPhone }
        ]
      },
      redirect: ""
    };
  },
  components: {
    PortalFooter: () => import("../portal/portal-footer")
  },
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    if (query.redirect) {
      // URL Encode
      this.redirect = decodeURIComponent(query.redirect);
    } else {
      this.redirect = "/";
    }
  },
  methods: {
    handleRegister() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return false;
        }
        let that = this;
        if (that.form.telephone === null) {
          that.$message.warning("手机号必须填写");
          return false;
        }
        if (that.sms.telephone === null) {
          that.$message.warning("验证码必须获取");
          return false;
        }
        if (that.sms.telephone.toString() !== that.form.telephone.toString()) {
          that.$message.warning("【非法登录】手机号不匹配");
          return false;
        }
        let form = {
          userId: null,
          telephone: that.form.telephone,
          verifyGuid: that.form.verifyGuid,
          verifySms: that.form.verifySms,
          account: {
            userPwd: encryptByDES(
              that.form.password,
        _security.webSecurityKey,
        _security.webSecurityVI
            )
          }
        };
        that.loading.display = true;
        doRegister(form).then(res => {
          that.loading.display = false;
          if (!res||!res.success) return;
          that.$message.success("注册成功,请登录");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 2000);
          that.sms.second = 0;
        });
      });
    },

    handleVerifyCode() {
      let that = this;
      if (!validatePhone(that.form.telephone.toString())) {
        that.$message.warning("请输入正确的11位手机号码");
        return false;
      }
      that.form.verifyGuid = encryptByDES(
        newGuid(),
        _security.webSecurityKey,
        _security.webSecurityVI
      );

      that.loading.display = true;
      doSms("register", that.form.telephone, that.form.verifyGuid).then(res => {
        that.loading.display = false;
        if (!res) return;
        that.sms.telephone = that.form.telephone.toString();
        that.sms.second = res.data.second;
        clearInterval(that.sms.timer);
        that.sms.timer = setInterval(function() {
          if (that.sms.second <= 0) {
            that.sms.label = "点击重新发送";
            that.sms.disabled = false;
          } else {
            that.sms.disabled = true;
            that.sms.label = "剩余时间" + that.sms.second + "秒";
            that.sms.second--;
          }
        }, 1000);
      });
    },
    handleReset() {
      this.$refs["form"].resetFields();
    },
    goLogin() {
      this.$router.push({ path: "/login" });
    }
  }
};
</script>
<style type="text/scss" lang="scss">
@import "../../styles/login/index";
</style>
